import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { Leilao02Component  } from './Leiloes/leilao02/leilao02.component';
import { HomeComponent } from './home/home.component';
import { Leilao01Component } from './Leiloes/leilao01/leilao01.component';
import { Leilao03Component } from './Leiloes/leilao03/leilao03.component';
import { Leilao04Component } from './Leiloes/leilao04/leilao04.component';
import { Leilao05Component } from './Leiloes/leilao05/leilao05.component';
import { Leilao06Component } from './Leiloes/leilao06/leilao06.component';
import { Leilao07Component } from './Leiloes/leilao07/leilao07.component';
import { Leilao08Component } from './Leiloes/leilao08/leilao08.component';
import { Leilao09Component } from './Leiloes/leilao09/leilao09.component';
import { Leilao10Component } from './Leiloes/leilao10/leilao10.component';
import { Leilao11Component } from './Leiloes/leilao11/leilao11.component';



@NgModule({
  declarations: [
    AppComponent,
    Leilao01Component,
    Leilao02Component,
    Leilao03Component,
    Leilao04Component,
    HomeComponent,
    Leilao05Component,
    Leilao06Component,
    Leilao07Component,
    Leilao08Component,
    Leilao09Component,
    Leilao10Component,
    Leilao11Component
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
